<template>
  <div class="add-stage-page" v-if="true">
    <van-cell-group class="cell-group">
      <van-field label="阶段名称" v-model="stageName" placeholder="输入阶段名称" />
      <van-field
        label="开始时间"
        v-model="start_at"
        readonly
        @click="(time = 1) && (show = !show)"
        placeholder="设置开始时间"
      />
      <van-field
        label="结束时间"
        v-model="end_at"
        readonly
        @click="(time = 2) && (show = !show)"
        placeholder="设置结束时间"
      />
    </van-cell-group>

    <div class="display bottom-line">
      <div>奖励总金额：{{totalBonusPool}}元</div>
      <div>可用金额：{{availableBonusPool}}元</div>
    </div>
    <van-field label="本阶段使用金额" v-model.number="bonus_pool" type="number" placeholder="输入金额" />

    <div>
      <div class="display bottom-line">
        <div class="tip">所有导购员任务统一设置</div>
      </div>
      <div class="field">
        <div class="input line">
          <div>浏览数量</div>
          <van-field type="number" v-model.number="staffviewNum" />
        </div>
        <div class="input line">
          <div>裂变数量</div>
          <van-field type="number" v-model.number="stafffissionNum" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>报名数量</div>
          <van-field type="number" v-model.number="staffenrollmentNum" />
        </div>
        <div class="input line">
          <div>售券数量</div>
          <van-field type="number" v-model.number="staffcardNum" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>秒杀数量</div>
          <van-field type="number" v-model.number="staffseckillUserNum" />
        </div>
        <div class="input line">
          <div>集赞数量</div>
          <van-field type="number" v-model.number="staffthumbNum" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>进入直播间数量</div>
          <van-field type="number" v-model.number="staffliveViewNum" />
        </div>
        <div class="input line">
          <div>直播下订</div>
          <van-field type="number" v-model.number="staffliveOrderCusNum" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播自签单</div>
          <van-field type="number" v-model.number="staffliveSelfOrderNum" />
        </div>
        <div class="input line">
          <div>直播贡献单</div>
          <van-field type="number" v-model.number="staffliveOtherOrderNum" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播自签转单</div>
          <van-field type="number" v-model.number="staffliveSelfOrderChangeNum" />
        </div>
        <div class="input line">
          <div>直播贡献转单</div>
          <van-field type="number" v-model.number="staffliveOtherOrderChangeNum" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>过程自签单</div>
          <van-field type="number" v-model.number="staffprocessSelfOrderNum" />
        </div>
        <div class="input line">
          <div>过程贡献单</div>
          <van-field type="number" v-model.number="staffprocessDevoteOrderNum" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播预约数量</div>
          <van-field type="number" v-model.number="staffappointmentNum" />
        </div>
        <div class="input line"></div>
      </div>
    </div>

    <div style="margin-bottom:10px;">
      <div class="display bottom-line">
        <div class="tip">所有品牌任务统一设置</div>
      </div>
      <div class="field">
        <div class="input line">
          <div>浏览数量</div>
          <van-field type="number" v-model.number="brandviewNum" />
        </div>
        <div class="input line">
          <div>浏览惩罚金</div>
          <van-field type="number" v-model.number="brandviewNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>裂变数量</div>
          <van-field type="number" v-model.number="brandfissionNum" />
        </div>
        <div class="input line">
          <div>裂变惩罚金</div>
          <van-field type="number" v-model.number="brandfissionNumPenalty" />
        </div>
      </div>

      <div class="field">
        <div class="input line">
          <div>报名数量</div>
          <van-field type="number" v-model.number="brandenrollmentNum" />
        </div>
        <div class="input line">
          <div>报名惩罚金</div>
          <van-field type="number" v-model.number="brandenrollmentNumPenalty" />
        </div>
      </div>

      <div class="field">
        <div class="input line">
          <div>售券数量</div>
          <van-field type="number" v-model.number="brandcardNum" />
        </div>
        <div class="input line">
          <div>售券惩罚金</div>
          <van-field type="number" v-model.number="brandcardNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>秒杀数量</div>
          <van-field type="number" v-model.number="brandseckillUserNum" />
        </div>
        <div class="input line">
          <div>秒杀惩罚金</div>
          <van-field type="number" v-model.number="brandseckillUserNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>集赞数量</div>
          <van-field type="number" v-model.number="brandthumbNum" />
        </div>
        <div class="input line">
          <div>集赞惩罚金</div>
          <van-field type="number" v-model.number="brandthumbNumPenalty" />
        </div>
      </div>

      <div class="field">
        <div class="input line">
          <div>进入直播间数量</div>
          <van-field type="number" v-model.number="brandliveViewNum" />
        </div>
        <div class="input line">
          <div>进入直播间惩罚金</div>
          <van-field type="number" v-model.number="brandliveViewNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播下订</div>
          <van-field type="number" v-model.number="brandliveOrderCusNum" />
        </div>
        <div class="input line">
          <div>直播下订惩罚金</div>
          <van-field type="number" v-model.number="brandliveOrderCusNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播自签单订单</div>
          <van-field type="number" v-model.number="brandliveSelfOrderNum" />
        </div>
        <div class="input line">
          <div>直播自签单惩罚金</div>
          <van-field type="number" v-model.number="brandliveSelfOrderNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播贡献单订单</div>
          <van-field type="number" v-model.number="brandliveOtherOrderNum" />
        </div>
        <div class="input line">
          <div>直播贡献单惩罚金</div>
          <van-field type="number" v-model.number="brandliveOtherOrderNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播自签转单</div>
          <van-field type="number" v-model.number="brandliveSelfOrderChangeNum" />
        </div>
        <div class="input line">
          <div>直播自签转单惩罚金</div>
          <van-field type="number" v-model.number="brandliveSelfOrderChangeNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播贡献转单</div>
          <van-field type="number" v-model.number="brandliveOtherOrderChangeNum" />
        </div>
        <div class="input line">
          <div>直播贡献转单惩罚金</div>
          <van-field type="number" v-model.number="brandliveOtherOrderChangeNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>过程自签单</div>
          <van-field type="number" v-model.number="brandprocessSelfOrderNum" />
        </div>
        <div class="input line">
          <div>过程自签单惩罚金</div>
          <van-field type="number" v-model.number="brandprocessSelfOrderNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>过程贡献单</div>
          <van-field type="number" v-model.number="brandprocessDevoteOrderNum" />
        </div>
        <div class="input line">
          <div>过程贡献单惩罚金</div>
          <van-field type="number" v-model.number="brandprocessDevoteOrderNumPenalty" />
        </div>
      </div>
      <div class="field">
        <div class="input line">
          <div>直播预约</div>
          <van-field type="number" v-model.number="brandappointmentNum" />
        </div>
        <div class="input line">
          <div>直播预约惩罚金</div>
          <van-field type="number" v-model.number="brandappointmentPenalty" />
        </div>
      </div>
    </div>
    <van-cell title="所有品牌调整设置" is-link value="去设置" class="bottom" :to="{ name: 'kpi.punish'}" />

    <div class="sure-btn">
      <van-button type="info" @click="SaveStep">确认添加</van-button>
    </div>

    <van-popup v-model="show" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="show = false"
      />
    </van-popup>

    <!-- <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { activity_id: activity.id, user_id: user_id, kpi_uid: kpi_uid, share_uid: share_uid }}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity: {},
      user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      user: null,
      kpi_user: null,
      kpi: null,
      stageName: "",
      bonus_pool: "",
      start_at: "",
      end_at: "",
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      show: false,
      time: 0,
      // 导购员参数
      staffviewNum: 0,
      stafffissionNum: 0,
      staffenrollmentNum: 0,
      staffcardNum: 0,
      staffseckillUserNum: 0,
      staffthumbNum: 0,
      staffliveViewNum: 0,
      staffliveOrderCusNum: 0,
      staffliveSelfOrderNum: 0,
      staffliveOtherOrderNum: 0,
      staffliveSelfOrderChangeNum: 0,
      staffliveOtherOrderChangeNum: 0,
      staffprocessSelfOrderNum: 0,
      staffprocessDevoteOrderNum: 0,
      staffappointmentNum: 0,

      // 品牌参数
      brandviewNum: 0,
      brandviewNumPenalty: 0,
      brandfissionNum: 0,
      brandfissionNumPenalty: 0,
      brandenrollmentNum: 0,
      brandenrollmentNumPenalty: 0,
      brandcardNum: 0,
      brandcardNumPenalty: 0,
      brandseckillUserNum: 0,
      brandseckillUserNumPenalty: 0,
      brandthumbNum: 0,
      brandthumbNumPenalty: 0,
      brandliveViewNum: 0,
      brandliveViewNumPenalty: 0,
      brandliveOrderCusNum: 0,
      brandliveOrderCusNumPenalty: 0,
      brandliveSelfOrderNum: 0,
      brandliveSelfOrderNumPenalty: 0,
      brandliveOtherOrderNum: 0,
      brandliveOtherOrderNumPenalty: 0,
      brandliveSelfOrderChangeNum: 0,
      brandliveSelfOrderChangeNumPenalty: 0,
      brandliveOtherOrderChangeNum: 0,
      brandliveOtherOrderChangeNumPenalty: 0,
      brandprocessSelfOrderNum: 0,
      brandprocessSelfOrderNumPenalty: 0,
      brandprocessDevoteOrderNum: 0,
      brandprocessDevoteOrderNumPenalty: 0,
      brandappointmentNum: 0,
      brandappointmentPenalty: 0,
      // 奖励总金额和可用金额
      availableBonusPool: 0,
      totalBonusPool: 0,
    };
  },
  created() {
    // this.maxDate.setFullYear(this.minDate.getFullYear() + 1);// 设置最大年份为第二年
    this.actId = localStorage.getItem("act_id");
    this.QueryActAcount();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    // 获取奖励总金额和可用金额
    async QueryActAcount() {
      let res = await this.$http.post(
        "/v1/taskmanage/query_act_acount_by_act_id"
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.availableBonusPool = res.data.availableBonusPool;
        this.totalBonusPool = res.data.totalBonusPool;
      }
    },
    // 新建
    async SaveStep() {
      var actId = localStorage.getItem("act_id");
      let act = {
        actId: actId,
        // brandBonusPool: this.bonus_pool,
        brandStepDTO: {
          actId: actId,
          brandId: 0, //0为默认设置
          cardNum: this.brandcardNum,
          cardPenalty: this.brandcardNumPenalty,
          enrollmentNum: this.brandenrollmentNum,
          enrollmentPenalty: this.brandenrollmentNumPenalty,
          fissionNum: this.brandfissionNum,
          fissionPenalty: this.brandfissionNumPenalty,
          // id: 0,//新建时不传
          liveOrderCusNum: this.brandliveOrderCusNum,
          liveOrderCusPenalty: this.brandliveOrderCusNumPenalty,
          liveOtherOrderChangeNum: this.brandliveOtherOrderChangeNum,
          liveOtherOrderChangePenalty: this.brandliveOtherOrderChangeNumPenalty,
          liveOtherOrderNum: this.brandliveOtherOrderNum,
          liveOtherOrderPenalty: this.brandliveOtherOrderNumPenalty,
          liveSelfOrderChangeNum: this.brandliveSelfOrderChangeNum,
          liveSelfOrderChangePenalty: this.brandliveSelfOrderChangeNumPenalty,
          liveSelfOrderNum: this.brandliveSelfOrderNum,
          liveSelfOrderPenalty: this.brandliveSelfOrderNumPenalty,
          liveViewNum: this.brandliveViewNum,
          liveViewPenalty: this.brandliveViewNumPenalty,
          processDevoteOrderNum: this.brandprocessDevoteOrderNum,
          processDevoteOrderPenalty: this.brandprocessDevoteOrderNumPenalty,
          appointmentNum: this.brandappointmentNum,
          appointmentPenalty: this.brandappointmentPenalty,
          processSelfOrderNum: this.brandprocessSelfOrderNum,
          processSelfOrderPenalty: this.brandprocessSelfOrderNumPenalty,
          seckillUserNum: this.brandseckillUserNum,
          seckillUserPenalty: this.brandseckillUserNumPenalty,
          // stepId: 0,//新建时不传
          thumbNum: this.brandthumbNum,
          thumbPenalty: this.brandthumbNumPenalty,
          // updateTime: "2020-07-24T08:22:14.481Z",
          viewNum: this.brandviewNum,
          viewPenalty: this.brandviewNumPenalty,
        },
        cleared: false,
        startTime: this.start_at,
        finishTime: this.end_at,
        // startTime: '2021-07-18 18:20:20',
        // finishTime: '2021-07-19 18:20:20',
        // id: 0,
        name: this.stageName,
        staffBonusPool: this.bonus_pool,
        staffStepDTO: {
          actId: actId,
          cardNum: this.staffcardNum,
          // createTime: "2020-07-24T08:22:14.482Z",
          enrollmentNum: this.staffenrollmentNum,
          fissionNum: this.stafffissionNum,
          // id: 0,
          liveOrderCusNum: this.staffliveOrderCusNum,
          liveOtherOrderChangeNum: this.staffliveOtherOrderChangeNum,
          liveOtherOrderNum: this.staffliveOtherOrderNum,
          liveSelfOrderChangeNum: this.staffliveSelfOrderChangeNum,
          liveSelfOrderNum: this.staffliveSelfOrderNum,
          liveViewNum: this.staffliveViewNum,
          processDevoteOrderNum: this.staffprocessDevoteOrderNum,
          appointmentNum: this.staffappointmentNum,
          processSelfOrderNum: this.staffprocessSelfOrderNum,
          seckillUserNum: this.staffseckillUserNum,
          // stepId: 0,
          thumbNum: this.staffthumbNum,
          // updateTime: "2020-07-24T08:22:14.482Z",
          viewNum: this.staffviewNum,
        },
      };

      if (!this.stageName) {
        this.$toast("请设置阶段名称");
        return;
      }
      if (!this.start_at) {
        this.$toast("请设置开始时间");
        return;
      }
      if (!this.end_at) {
        this.$toast("请设置结束时间");
        return;
      }
      console.log(this.bonus_pool);
      if (this.bonus_pool !== 0 && !this.bonus_pool) {
        this.$toast("请输入本阶段使用金额");
        return;
      }
      if (Number(this.bonus_pool) > Number(this.availableBonusPool)) {
        this.$toast("本阶段使用金额不可大于可用金额");
        return;
      }
      let res = await this.$http.post(
        "/v1/taskmanage/save_or_update_step",
        act
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.$toast("新建成功");
        this.$router.push({
          path: "/kpi/bonuspool",
          query: {
            act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
          },
        });
      }
    },
    onConfirm(value) {
      this.show = !this.show;
      var date = new Date(value);
      var time =
        date.getFullYear() +
        "-" +
        this.format(date.getMonth() + 1) +
        "-" +
        this.format(date.getDate()) +
        " " +
        this.format(date.getHours()) +
        ":" +
        this.format(date.getMinutes()) +
        ":" +
        this.format(date.getSeconds());
      if (this.time === 1) {
        this.start_at = time;
      } else if (this.time === 2) {
        this.end_at = time;
      }
      if (
        this.start_at &&
        this.end_at &&
        new Date(this.start_at).getTime() > new Date(this.end_at).getTime()
      ) {
        this.$toast("开始时间不能大于结束时间");
        this.start_at = "";
        this.end_at = "";
      }
    },
    /**
     * 添加任务阶段
     */

    format(value) {
      if (value >= 1 && value <= 9) {
        value = "0" + value;
      }
      return value;
    },
  },
};
</script>

<style lang="less">
.add-stage-page {
  font-size: 14px;
  padding-bottom: 30px;
  .van-field__control {
    text-align: right;
  }
  .van-field__label {
    max-width: 100px;
  }
  .display {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    padding: 12px 15px;
    div:last-child {
      color: #3283fa;
    }
  }
  .bottom-line::after {
    left: 15px;
  }
  .sure-btn {
    width: 100%;
    margin-top: 30px;
    text-align: center;
    .van-button {
      width: 90%;
    }
  }

  .field {
    /*将两个输入框水平放置*/
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 10px 11px;
    .line {
      padding: 0 4px;
      flex: 1;
      font-size: 12px;
    }
  }
  .input {
    /*将两个输入框水平放置*/
    display: flex;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    background-color: #ffffff;
    color: #323232;
    .van-cell {
      width: 40%;
      font-size: 18px;
      padding: 0px;
      .van-field__control {
        text-align: right;
        font-size: 14px;
        color: #5293fd;
        padding: 0 5px;
        line-height: 22px;
      }
    }
    input:focus {
      background-color: #eeeeee;
      border-radius: 2px;
      text-align: left !important;
    }
  }
}
</style>
